<template>
  <div>
    <div>
      <el-row style="height:120px;background:white" align="middle" type="flex">
        <el-col :span="6">
          <div style="paddingLeft:10px">
            寄卖平台地址
          </div>
        </el-col>
        <el-col :span="12">
          <p>
            联系人:{{platAddress.realname}} <br />
            联系电话:{{platAddress.phone}}<br />
            地址:：{{platAddress.address}} <br />
          </p>
        </el-col>
        <el-col :span="4">
          {{platAddress.updateTime}}
        </el-col>
        <el-col :span="2">
          <el-button @click="edit" v-if="userInfo.type!=3">编辑</el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog title="寄卖平台地址" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="platAddressForm"
            :model="platAddressForm"
            label-width="130px"
          >
            <el-form-item label="联系人" prop="realname">
              <el-input clearable v-model="platAddressForm.realname"
                ></el-input
              >
            </el-form-item>
            <el-form-item label="联系电话: " prop="phone">
              <el-input clearable v-model="platAddressForm.phone"
                ></el-input
              >
            </el-form-item>
            <el-form-item label="地址: " prop="address">
              <el-input clearable v-model="platAddressForm.address"
                ></el-input
              >
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEdit"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "autoQuotation",
  components: {},
  data() {
    return {
      userInfo:{},
      isDlg: false,
      platAddress:{},
      platAddressForm: {
        realname:"",
        phone:"",
        address:"",
      },
    };
  },
  mounted() {
    this.getPlatInfo();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")).data;
  },
  methods: {
    getPlatInfo(){
        let self = this;
        self.$api
        .getPlatInfo()
        .then((res) => {
          if (res.code === 200) {
            self.platAddress = res.data[0];
          }
        });
    },
    edit() {
      this.platAddressForm = this.platAddress;
      this.isDlg = true;
    },
    submitEdit() {
      let self = this;
  
        self.$api
        .updatePlatInfo(self.platAddressForm)
        .then((res) => {
          if (res.code === 200) {
              this.$message({
              message: "更新成功",
              type: "success",
            });
            self.getPlatInfo();
            this.isDlg = false;
          }
        });
     
    },
    closeEditorDlg() {
      this.isDlg = false;
    },
  },
};
</script>

<style lang="less" scoped></style>
